import * as giftCardShelfData from '../services/giftCardShelfData';

export default {
  namespace: 'giftCardShelfData',
  state: {
    cardData: null,
  },
  effects: {
    *getGiftList({ payload: { values } }, { call, put }) {
      const res = yield call(giftCardShelfData.getGiftList, values);
      yield put({
        type: 'save',
        payload: {
          cardData: res.data,
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup() {},
  },
};
